document.addEventListener("DOMContentLoaded", function() {
  
  // Selecciona todas las instancias del menú (por si agregas la sección 2 veces)
  const navContainers = document.querySelectorAll('.js-secondary-nav');

  navContainers.forEach(container => {
    const viewport = container.querySelector('.js-nav-viewport');
    const prevBtn = container.querySelector('.js-nav-prev');
    const nextBtn = container.querySelector('.js-nav-next');

    if (!viewport || !prevBtn || !nextBtn) return;

    // Lógica para mostrar/ocultar flechas
    const checkScroll = () => {
      const tolerance = 2; // Tolerancia en píxeles
      // Hay desbordamiento si el contenido es más ancho que el contenedor visible
      const isOverflowing = viewport.scrollWidth > viewport.clientWidth;
      
      if (isOverflowing) {
        // Mostrar flecha izq si no estamos al principio
        prevBtn.style.display = viewport.scrollLeft > 0 ? 'block' : 'none';
        
        // Mostrar flecha der si no estamos al final
        const remainingSpace = viewport.scrollWidth - (viewport.scrollLeft + viewport.clientWidth);
        nextBtn.style.display = remainingSpace > tolerance ? 'block' : 'none';
      } else {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      }
    };

    // Listeners para los botones
    prevBtn.addEventListener('click', () => {
      viewport.scrollBy({ left: -200, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      viewport.scrollBy({ left: 200, behavior: 'smooth' });
    });

    // Listeners para actualizar flechas al hacer scroll o redimensionar ventana
    viewport.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    
    // Verificación inicial
    // Un pequeño timeout asegura que el DOM esté completamente renderizado y con anchos calculados
    setTimeout(checkScroll, 150); 
  });
});